export default __webpack_public_path__ + "static/media/Baby.e0b1edac.png";